import CIcon from '@coreui/icons-react';
import { CButton, CForm } from '@coreui/react';
import { Formik } from 'formik';
import get from 'lodash/get';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Select from 'react-select';
import * as Yup from 'yup';
import { callTokenApi } from '../../../../apiCaller';
import { API_CLIENT_REPORT_FILTER_CHECKLIST, DATA_SOURCE_EXTERNAL_OBJECT, DEFAULT_DATE_FORMAT } from '../../../../constants';
import {
     COMPANY_CHECKLIST_TYPES,
     CHECKLIST_OPTION,
     EXCLUDE_CHECK_LIST_OPERATOR_OPTION,
     IGNORE_FILTER_OPTIONS,
     OPTIONS_VALUES_FILTER_REPORT,
     REPORT_NAMES,
     REPORT_TAB_TYPES,
     REPORT_TYPE,
     VARIABLE_OPERATORS_DIMENSION_REPORT,
     VARIABLE_OPERATORS_DIMENSION_REPORT_DATE,
     VARIABLE_OPERATORS_METRICS_REPORT,
     VARIABLE_OPERATORS_REPORT,
     listOptionsAddmore,
     FILTER_FORMAT,
     FILTER_FORMAT_FIELDS,
     BOOLEAN_FIELD,
     BOOLEAN_FIELD_OPTIONS,
     DATE_FILTER_TYPES,
     CHECKLIST_OPTION_ARRAY,
     VARIABLE_OPERATORS_BOOLEAN_REPORT,
     OPTIONS_FILTER_STATUS,
     VARIABLE_OPERATORS_EMPTY_REPORT,
     EXISTS_WITH_ANY_VALUE_OPERATOR_OPTION,
     REPORT_DATA_TYPES,
     MERGE_REPORT_NAME,
     DOES_NOT_EXIST_OPERATOR_OPTION,
     CHECKLIST_TYPE,
     CHECK_LIST_FIELD,
     YES_NO_FIELD,
     YES_NO_FIELD_OPTIONS,
} from '../../../../constants/analytics';
import SelectSearchField from '../../../general/custom-search-select/SelectSearchField';
import SelectField from '../../../general/multiselect/SelectField';
import CustomFilterDatePicker from './CustomFilterDatePicker';
import { EventExplorerContext } from './EventExplorer';
import { isEqual } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { CInput } from '../../../migration/CInput';
import { CInvalidFeedback } from '../../../migration/CInvalidFeedback';
import CLabel from '../../../migration/CLabel';
import CFormGroup from '../../../migration/CFormGroup';
import LazyLoadSelect from '../../../general/multiselect/LazyLoadSelect';
import CenterSpinner from '../../../general/Loadings/CenterSpinner';
import { generateCustomDimensionName, removeDuplicateValueInArray } from '../../../../utils';
import { INTENT_PROPERTIES_STORE } from '../../../../constants/intent-rules';
import PropTypes from 'prop-types';

const validationSchema = () => {
     return Yup.array(
          Yup.object().shape({
               type: Yup.string().trim().required('field required'),
               value: Yup.string().trim().required('field required'),
          })
     );
};

const getFinalFilterOptions = (data) => {
     const { dataParamValue, reportName, options, filters, filterProperties, filterMetric, dimensions, filterDimensions } = data;
     const rejectOptions = [
          'personConvRate', 'userConvRate', 'sessionConvRate',
          'companyConvRate', 'viewDetail', 'purchaseConversionRate',
          // 'primaryConversionPrimaryObjectRate', 'conversionPrimaryRate', 'secondaryConversionPrimaryObjectRate',
          // 'conversionEventPrimaryObjectRate'
     ];
     let newOptions = options.filter((o) =>
          !rejectOptions.includes(o.value)
          && !o.value.includes('conversionRate')
          && !o.value.toLocaleLowerCase().includes('convrate')
          // && !(o.value.toLocaleLowerCase().includes('individual') && o.value.toLocaleLowerCase().includes('rate'))
     );

     const isFilterFromLink = dataParamValue?.filters && isEqual(dataParamValue.filters, filters);

     // If filter is not from link
     if (!isFilterFromLink && IGNORE_FILTER_OPTIONS[reportName]) {
          newOptions = newOptions.filter((o) => !IGNORE_FILTER_OPTIONS[reportName].includes(o.value));
     }

     const topSet = new Set([...filterDimensions, ...filterProperties, ...filterMetric].map(e => e.value));
     newOptions = newOptions.filter((item) => {
          if (
               dimensions.some((e) => e.key === item.value || e.value === item.value) ||
               [...filterDimensions, ...filterProperties, ...filterMetric].some((e) => e.value === item.value)
          ) {
               return true;
          }
          return false;
     }).sort((a, b) => {
          const aTop = topSet.has(a.value);
          const bTop = topSet.has(b.value);

          if (aTop && !bTop) return -1;
          if (!aTop && bTop) return 1;

          return 0;
     });

     return newOptions;
};

const ButtonClearAll = ({ handleClearAll, triggerClear, setTriggerClear }) => {
     useEffect(() => {
          if (triggerClear) {
               handleClearAll();
               setTriggerClear(false);
          }
     }, [triggerClear]); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <CButton onClick={handleClearAll}>
               <CLabel>clear all</CLabel>
               <CIcon icon="iconDeleteCircle" />
          </CButton>
     );
};

const FilterReport = () => {
     const history = useHistory();
     const {
          reportType,
          filterEvent,
          setFilterEvent,
          setFilterEventReport,
          filterEventReport,
          reportName,
          filterMetric,
          filterDimensions,
          filterProperties,
          filterOptions,
          showData,
          setChangeData,
          recordProfile,
          newDateRange,
          customDimensionInfo,
          scoped,
          dataParamValue,
          isChangeScope,
          triggerClear,
          setTriggerClear,
          handleFindView,
          conversionName,
          listDynamicFields,
          intentProperties,
          dateRangeConfig,
          rerunValueChange,
          setRerunValueChange
     } = useContext(EventExplorerContext);
     const isFilter = useRef(false);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const { validateEmailStatus } = activeAccount;
     const dateRangeReports = useSelector((state) => state.subscriber.dateRangeReports);
     const intentCellState = useSelector((state) => state.subscriber.intentCellState);

     const [checklistData, setChecklistData] = useState(null);
     const [formKey, setFormKey] = useState(0);
     const [reloadFilter, setReloadFilter] = useState(false);

     const defaultRow = [
          {
               type: '',
               value: '',
               id: '',
               operator: 'ct',
               optionsOperator: VARIABLE_OPERATORS_REPORT,
          },
     ];
     const { dimensions, requireDimensions } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
     const defaultValues = OPTIONS_VALUES_FILTER_REPORT[reportName];
     const formatFields = FILTER_FORMAT_FIELDS[FILTER_FORMAT.DATE];
     const propertyDynamic = listDynamicFields?.properties?.length > 0 ? listDynamicFields?.properties : [];

     const [localFilterEvent, setLocalFilterEvent] = useState(() => (dataParamValue || filterEvent) && cloneDeep(filterEvent));
     const reloadForm = () => {
          // Tăng giá trị của key để khiến React render lại component Formik
          setFormKey((prevKey) => prevKey + 1);
     };
     useEffect(() => {
          reloadForm();
     }, [filterMetric, filterProperties, filterDimensions]); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          if (isChangeScope.current) {
               setLocalFilterEvent(defaultRow);
          }
     }, [scoped]); // eslint-disable-line react-hooks/exhaustive-deps
     useEffect(() => {
          setLocalFilterEvent(() => (dataParamValue || filterEvent) && cloneDeep(filterEvent));
     }, [filterEvent]); // eslint-disable-line react-hooks/exhaustive-deps

     const intentRerunResultsLength = Object.values(intentCellState || {}).filter((item) => typeof item.result !== 'undefined').length;

     useEffect(() => {
          // Show message and enable apply filter button when rerun intent result is changed
          if (intentRerunResultsLength > 0 && localFilterEvent.some((el) => el.type?.includes('IntentCustom'))) {
               setRerunValueChange(true);
          }
     }, [intentRerunResultsLength]); // eslint-disable-line react-hooks/exhaustive-deps

     const dateRanges = {
          selection: {
               startDate: dateRangeReports?.selection?.startDate?.format(DEFAULT_DATE_FORMAT),
               endDate: dateRangeReports?.selection?.endDate?.format(DEFAULT_DATE_FORMAT),
          },
     };
     const customPropertiesNotSelect = [];
     const customDimensionsNotSelect = [];

     customDimensionInfo.forEach((element) => {
          if (
               !filterProperties.find((e) => e.value === element.properties) &&
               !filterDimensions.find((e) => e.value === element.properties)
          ) {
               customPropertiesNotSelect.push(element.properties);
          }
          if (
               !filterDimensions.find((e) => e.value === element.properties)
          ) {
               customDimensionsNotSelect.push(element.properties);
          }
     });

     const initFilterOptions = filterOptions.filter((item) => {
          const listOption = item.value !== customPropertiesNotSelect.find((el) => el === item.value) || item.value !== customDimensionsNotSelect.find((el) => el === item.value);
          if (!recordProfile) return listOption;
          return listOption && item.value !== localFilterEvent[0].type;
     });

     const typeOptions = getFinalFilterOptions({
          dataParamValue,
          reportName,
          options: initFilterOptions || filterOptions,
          filters: localFilterEvent,
          scoped,
          dimensions: MERGE_REPORT_NAME.includes(reportName) ? requireDimensions : [REPORT_NAMES.BY_CONVERSION, REPORT_NAMES.BY_PROPERTY, REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION, REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY].includes(reportName) ? filterDimensions : dimensions,
          filterDimensions,
          filterProperties,
          filterMetric,
          dateRangeConfig
     });

     const checklistOptions = {};

     if (checklistData) {
          Object.entries(checklistData).forEach(([key, value]) => {
               checklistOptions[key] = value.map((item) => ({
                    label: item,
                    value: item,
               }));
          });

          if (checklistOptions?.primaryIndustry) {
               checklistOptions.currentPrimaryIndustry = checklistOptions?.primaryIndustry;
               checklistOptions.currentCompanyPrimaryIndustry = checklistOptions?.primaryIndustry;
          }
          if (checklistOptions?.revenue) {
               checklistOptions.currentRevenue = checklistOptions?.revenue;
               checklistOptions.currentCompanyRevenue = checklistOptions?.revenue;
          }

          if (![REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION, REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY, REPORT_NAMES.SALES_CONVERSION_EVENTS].includes(reportName) && checklistOptions?.conversionNameLL) {
               checklistOptions.conversionName = checklistOptions?.conversionNameLL;
          }
     }
     const fetchCheckListData = () => {
          const reqData = {
               accountId: activeAccount.id,
               dateRanges,
               types: [REPORT_NAMES.SALES_CONVERSION_BY_CONVERSION, REPORT_NAMES.SALES_CONVERSION_BY_PROPERTY, REPORT_NAMES.SALES_CONVERSION_EVENTS].includes(reportName) ? ['conversionName'] : []
          };

          setReloadFilter(true)
          callTokenApi(API_CLIENT_REPORT_FILTER_CHECKLIST, 'POST', reqData).then((response) => {
               if (response?.status === 200) {
                    setChecklistData(response.data.checklistData);
               }
               setReloadFilter(false)
          });
     };

     useEffect(() => {
          if (
               [REPORT_NAMES.COMPANY_DETAILS, REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.CONVERSION_EVENTS, REPORT_NAMES.CHANNEL_REPORT, REPORT_NAMES.FORM_SUBMISSION_EVENTS, REPORT_NAMES.USER_DETAILS, REPORT_NAMES.SESSION_DETAILS, REPORT_NAMES.SALES_CONVERSION_EVENTS].includes(reportName)
               || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL, REPORT_TYPE.SALES_CONVERSION, REPORT_TYPE.CONVERSIONS, REPORT_TYPE.ATTRIBUTES, REPORT_TYPE.ACQUISITION, REPORT_TYPE.ENGAGEMENT, REPORT_TYPE.ECOMMERCE].includes(reportType)
          ) {
               fetchCheckListData();
          }
     }, [reportName, dateRangeReports]); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          if (filterEvent[0]?.type !== defaultRow[0]?.type) {
               isFilter.current = true;
          }
          if (!recordProfile) {
               setLocalFilterEvent(cloneDeep(filterEvent));
          }
     }, [reportName, dateRangeReports, filterProperties]); // eslint-disable-line react-hooks/exhaustive-deps

     const checkFieldDate = (value) => {
          if (intentProperties?.length > 0 && intentProperties.some((pro) => generateCustomDimensionName(`${pro?.name}_intent`) === value)) {
               return false
          }
          return value?.toLowerCase().includes('date')
     }
     const handleChangeOperatorFilter = ({ index, value, newFilterEvent = [] }) => {
          let operators = [];
          const findValueOfDimensions =
               filterDimensions.find((item) => item.value === value) || filterProperties.find((item) => item.value === value);
          const findValueOfMetric = filterMetric.find((item) => item.value === value);
          const findFieldDefault = defaultValues ? defaultValues.find((el) => el.key === value) : null;
          const findFieldPropertyDynamic = propertyDynamic.find((item) => item.key === value);
          const customDate = customDimensionInfo.find((_property) => _property.dataSource === DATA_SOURCE_EXTERNAL_OBJECT && _property.properties === value && (formatFields.includes(_property.pathPropertyName) || _property.pathPropertyName.toLowerCase().includes('date') || ['DATE', 'TIMESTAMP'].includes(_property.propertyType)) && ['FOL', 'LOL'].includes(_property.target));

          const customBoolean = customDimensionInfo.find((_property) => _property.dataSource === DATA_SOURCE_EXTERNAL_OBJECT && _property.properties === value && BOOLEAN_FIELD.includes(_property.pathPropertyName) && ['FOL', 'LOL'].includes(_property.target));
          const isBooleanField = BOOLEAN_FIELD.includes(value) || customBoolean;

          if (findValueOfDimensions) {
               if (['conversionValue'].includes(value) && reportName === REPORT_NAMES.SALES_CONVERSION_EVENTS) {
                    // For salesConversionEventsDetail: conversionValue supports both string (contain/not contain) and numeric operators
                    operators = [
                         { value: 'ct', label: 'contains' },
                         { value: 'nct', label: 'not contain' },
                         ...cloneDeep(VARIABLE_OPERATORS_METRICS_REPORT)
                    ];

                    if (![...VARIABLE_OPERATORS_METRICS_REPORT.map(item => item.value), 'ct', 'nct'].includes(newFilterEvent[index].operator)) {
                         newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'eq' };
                    }
               } else if (['sessionNumber', 'conversionValue', 'sessionCountRow', 'conversionCountRow', 'funnelOrder', 'engagedSessionCountRow', 'userCountRow', 'peopleCountRow'].includes(value)) {
                    operators = cloneDeep(VARIABLE_OPERATORS_METRICS_REPORT);

                    if (!VARIABLE_OPERATORS_METRICS_REPORT.find((item) => item.value === newFilterEvent[index].operator)) {
                         newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'eq' };
                    }
               } else if (checkFieldDate(value) || formatFields.includes(value) || customDate || (findFieldPropertyDynamic && ['DATE', 'TIMESTAMP'].includes(findFieldPropertyDynamic?.typeField))) {
                    operators = cloneDeep(VARIABLE_OPERATORS_DIMENSION_REPORT_DATE);
                    if (['latestSubmissionDate', 'lastConversionDate', 'revealedDate', 'providedDate', 'importedDate', 'dataSourcesRevealedDate', 'dataSourcesProvidedDate', 'dataSourcesImportedDate'].includes(value) || customDate || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL, REPORT_TYPE.SALES_CONVERSION].includes(reportType)) {
                         operators = [
                              { value: 'ct', label: 'contains' },
                              { value: 'nct', label: 'not contain' },
                              ...VARIABLE_OPERATORS_DIMENSION_REPORT_DATE,
                         ];
                    }
                    if (!VARIABLE_OPERATORS_DIMENSION_REPORT_DATE.find((item) => item.value === newFilterEvent[index].operator)) {
                         newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'on' };
                    }
               } else if (isBooleanField) {
                    operators = cloneDeep(VARIABLE_OPERATORS_BOOLEAN_REPORT);
               } else if (['qualityScore'].includes(value)) {
                    // Email Quality Score supports both string (contains/not contain) and numeric filtering.
                    // Default to 'equals to' (like the qualityScore sub-field in All Email Addresses).
                    operators = [
                         { value: 'ct', label: 'contains' },
                         { value: 'nct', label: 'not contain' },
                         ...cloneDeep(VARIABLE_OPERATORS_METRICS_REPORT),
                    ];
                    newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'eq' };
               } else {
                    operators = cloneDeep(VARIABLE_OPERATORS_DIMENSION_REPORT);

                    if (!VARIABLE_OPERATORS_DIMENSION_REPORT.find((item) => item.value === newFilterEvent[index].operator)) {
                         newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'ct' };
                    }
               }
          } else if (findValueOfMetric) {
               operators = cloneDeep(VARIABLE_OPERATORS_METRICS_REPORT);

               if (!VARIABLE_OPERATORS_METRICS_REPORT.find((item) => item.value === newFilterEvent[index].operator)) {
                    newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'eq' };
               }
          } else if (checkFieldDate(value) || formatFields.includes(value) || customDate || (findFieldPropertyDynamic && ['DATE', 'TIMESTAMP'].includes(findFieldPropertyDynamic?.typeField))) {
               operators = cloneDeep(VARIABLE_OPERATORS_DIMENSION_REPORT_DATE);
               if (['latestSubmissionDate', 'lastConversionDate'].includes(value) || customDate || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL, REPORT_TYPE.SALES_CONVERSION].includes(reportType)) {
                    operators = [
                         { value: 'ct', label: 'contains' },
                         { value: 'nct', label: 'not contain' },
                         ...VARIABLE_OPERATORS_DIMENSION_REPORT_DATE
                    ];
               }
               newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: 'on' };
          } else if (listOptionsAddmore.includes(value) || value.includes('step')) {
                    operators = cloneDeep(VARIABLE_OPERATORS_METRICS_REPORT);
                    newFilterEvent[index] = { ...newFilterEvent[index], [`operator`]: VARIABLE_OPERATORS_METRICS_REPORT[0].value };
               } else {
                    operators = cloneDeep(VARIABLE_OPERATORS_DIMENSION_REPORT);
               }
          const listDefaultFieldsWithCheckList = [...CHECK_LIST_FIELD[CHECKLIST_TYPE.CHANNEL], ...CHECK_LIST_FIELD[CHECKLIST_TYPE.USER_SOURCE]];
          // Add checklist operator option
          if (findValueOfDimensions && (COMPANY_CHECKLIST_TYPES.includes(findValueOfDimensions.value) || intentProperties.some((el) => [INTENT_PROPERTIES_STORE.MULTIPLE, INTENT_PROPERTIES_STORE.SINGLE].includes(el?.fieldType) && generateCustomDimensionName(`${el?.name}_intent`) === findValueOfDimensions?.value) || listDefaultFieldsWithCheckList.includes(findValueOfDimensions.value))) {
               if (!operators.some((item) => item.value === CHECKLIST_OPTION.value)) {
                    operators.push(CHECKLIST_OPTION);
               }
               if (!operators.some((item) => item.value === EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value)) {
                    operators.push(EXCLUDE_CHECK_LIST_OPERATOR_OPTION);
               }

               if (!operators.some((item) => item.value === EXISTS_WITH_ANY_VALUE_OPERATOR_OPTION.value)) {
                    operators.push(EXISTS_WITH_ANY_VALUE_OPERATOR_OPTION);
               }
               if (!operators.some((item) => item.value === DOES_NOT_EXIST_OPERATOR_OPTION.value) && (!!reportType || [REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.COMPANY_DETAILS])) {
                    operators.push(DOES_NOT_EXIST_OPERATOR_OPTION);
               }
          } else {
               operators = [...operators].filter((item) => item.value !== CHECKLIST_OPTION.value && item.value !== EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value);
          }
          
          if (findFieldDefault && findFieldDefault?.options) {
               operators = findFieldDefault?.options;
          }
          if (!recordProfile && (checkFieldDate(value) || formatFields.includes(value) || customDate)) {
               operators = [...operators, { value: 'dr', label: 'in the date range' }];
               if (['createdDate', 'creationDate'].includes(value) && (
                    [REPORT_NAMES.PERSON_DETAILS, REPORT_NAMES.COMPANY_DETAILS].includes(reportName)
                    || [REPORT_TYPE.SALE_FORCE, REPORT_TYPE.CUSTOM_EXTERNAL].includes(reportType)
               )) {
                    operators = [...operators, { value: 'ndr', label: 'not in the date range' }];
               }
          }
          return operators;
     };
     
     const handleSubmit = (values) => {
          if (!showData) return;

          setChangeData(true);
          isFilter.current = true;
          setFilterEvent(values);
          setFilterEventReport(!filterEventReport);
          setLocalFilterEvent(values);

          if (rerunValueChange) {
               setRerunValueChange(false);
          }

          if (reportName === 'eventDetails') {
               history.push(window.location.pathname);
          }

          handleFindView(REPORT_TAB_TYPES.FILTER, values);
     };

     const getOptionStatusField = ({ index, value, newFilterEvent = [], reportName }) => {
          const optionField = OPTIONS_FILTER_STATUS.find((o) => o.value === value);
          if (reportName === REPORT_NAMES.PERSON_DETAILS) {
               return { optionSubFields: optionField?.optionSubFields || [], optionsArray: optionField?.optionsArray || [] };
          }
          return { optionSubFields: [], optionsArray: [] };

     }
     return (
          <div className="filter-report">
               {reloadFilter ? (
                    <CenterSpinner />
               ) : (
                    <Formik
                         key={formKey}
                         initialValues={localFilterEvent}
                         validationSchema={validationSchema}
                         onSubmit={handleSubmit}
                         validateOnChange={false}
                         validateOnBlur={false}
                         enableReinitialize
                    >
                         {({
                              values,
                              errors,
                              handleChange,
                              handleSubmit,
                              setErrors,
                              isSubmitting,
                              setFieldValue,
                              setValues,
                              touched,
                              setFieldTouched,
                         }) => {
                              const handleChangeFilter = ({ valueFilter, position, type, field }) => {
                                   const { value } = valueFilter;
                                   const newFilterEvent = [...values];
                                   if (type === 'operatorSubField') {
                                        const isBooleanField = BOOLEAN_FIELD.includes(value) || ['roleEmail', 'disposableEmail', 'catchAllEmail', 'primary', 'currentB2BRole'].includes(value);
                                        if (isBooleanField) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: [VARIABLE_OPERATORS_BOOLEAN_REPORT[0]] };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_BOOLEAN_REPORT[0].value };
                                        } else if (['qualityScore'].includes(value)) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: VARIABLE_OPERATORS_METRICS_REPORT };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_METRICS_REPORT[0].value };
                                        } else if (VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === value)) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: [VARIABLE_OPERATORS_METRICS_REPORT[0]] };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_METRICS_REPORT[0].value };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: 'true' };
                                        } else {
                                             let newValue = value;
                                             if (value && field) {
                                                  newValue = `${field}-${value}`;
                                             }
                                             const optionsOperator = handleChangeOperatorFilter({
                                                  index: position,
                                                  value: newValue,
                                                  newFilterEvent: newFilterEvent,
                                             });
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: optionsOperator };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: optionsOperator[0].value };
                                        }
                                   }
                                   if (type === 'operatorArray') {
                                        const editRow = values[position];
                                        if (VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === value)) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: [VARIABLE_OPERATORS_METRICS_REPORT[0]] };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_METRICS_REPORT[0].value };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: 'true' };
                                        } else if (editRow?.operatorSubField) {
                                             const isBooleanField = BOOLEAN_FIELD.includes(editRow?.operatorSubField) || ['roleEmail', 'disposableEmail', 'catchAllEmail', 'primary', 'currentB2BRole'].includes(editRow?.operatorSubField);
                                             if (isBooleanField) {
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: [VARIABLE_OPERATORS_BOOLEAN_REPORT[0]] };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_BOOLEAN_REPORT[0].value };
                                             } else if (['qualityScore'].includes(editRow?.operatorSubField)) {
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: VARIABLE_OPERATORS_METRICS_REPORT };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: VARIABLE_OPERATORS_METRICS_REPORT[0].value };
                                             } else {
                                                  let newValue = value;
                                                  if (editRow?.operatorSubField && field) {
                                                       newValue = `${field}-${editRow?.operatorSubField}`;
                                                  }
                                                  const optionsOperator = handleChangeOperatorFilter({
                                                       index: position,
                                                       value: newValue,
                                                       newFilterEvent: newFilterEvent,
                                                  });
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: optionsOperator };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: optionsOperator[0].value };
                                             }

                                             if (
                                                  ['emailList', 'relatedCompanies', 'volunteering', 'certifications', 'education', 'projects', 'recommendations', 'otherRoles'].includes(editRow?.type) &&
                                                  ['allEmail', 'allCompanies', 'allVolunteering', 'allCertifications', 'allEducation', 'allProjects', 'allRecommendations', 'allOtherRoles'].includes(value)
                                             ) {
                                                  let newSubField = newFilterEvent[position]?.optionSubFields.filter((el) => !['primary', 'currentB2BRole'].includes(el.value));
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionSubFields`]: newSubField };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`operatorSubField`]: newSubField[0].value };
                                                  const optionsOperator = handleChangeOperatorFilter({
                                                       index: position,
                                                       value: newFilterEvent[position]?.type,
                                                       newFilterEvent: newFilterEvent,
                                                  });
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: optionsOperator };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: optionsOperator[0].value };

                                             }

                                             if (
                                                  ['emailList', 'relatedCompanies', 'volunteering', 'certifications', 'education', 'projects', 'recommendations', 'otherRoles'].includes(editRow?.type) &&
                                                  ['anyEmail', 'anyCompanies', 'anyVolunteering', 'anyCertifications', 'anyEducation', 'anyProjects', 'anyRecommendations', 'anyOtherRoles'].includes(value)
                                             ) {
                                                  const { optionSubFields } = getOptionStatusField({
                                                       index: position,
                                                       value: newFilterEvent[position].type,
                                                       newFilterEvent: newFilterEvent,
                                                       reportName
                                                  })
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionSubFields`]: optionSubFields };
                                                  newFilterEvent[position] = { ...newFilterEvent[position], [`optionSubField`]: optionSubFields[0].value };
                                             }
                                        } else {
                                             const optionsOperator = handleChangeOperatorFilter({
                                                  index: position,
                                                  value: field,
                                                  newFilterEvent: newFilterEvent,
                                             });
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: optionsOperator };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operator`]: optionsOperator[0].value };
                                        }
                                   }
                                   if (type === 'operator') {
                                        if (VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === value)) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: 'true' };
                                        }
                                   }
                                   if (type === 'type') {
                                        const optionsOperator = handleChangeOperatorFilter({
                                             index: position,
                                             value: value,
                                             newFilterEvent: newFilterEvent,
                                        });
                                        newFilterEvent[position] = { ...newFilterEvent[position], [`optionsOperator`]: optionsOperator };

                                        const { optionSubFields, optionsArray } = getOptionStatusField({
                                             index: position,
                                             value: value,
                                             newFilterEvent: newFilterEvent,
                                             reportName
                                        })

                                        if (optionSubFields?.length > 0) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionSubFields`]: optionSubFields };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operatorSubField`]: optionSubFields[0].value };
                                        } else {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionSubFields`]: [] };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operatorSubField`]: '' };
                                        }
                                        if (optionsArray?.length > 0) {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsArray`]: optionsArray };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operatorArray`]: optionsArray[0].value };
                                        } else {
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`optionsArray`]: [] };
                                             newFilterEvent[position] = { ...newFilterEvent[position], [`operatorArray`]: '' };
                                        }
                                   }
                                   if (value === 'dr' || value === 'ndr') {
                                        newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: newDateRange };
                                   } else if (valueFilter.value.includes('Date') && ['dr', 'ndr'].includes(newFilterEvent[position].operator)) {
                                        newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: newDateRange };
                                   } else if (!VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === value)) {
                                        newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: '' };
                                   }

                                   newFilterEvent[position] = { ...newFilterEvent[position], [`${type}`]: value };

                                   if (type === 'operator' && [EXISTS_WITH_ANY_VALUE_OPERATOR_OPTION.value, DOES_NOT_EXIST_OPERATOR_OPTION.value].includes(value)) {
                                        newFilterEvent[position] = { ...newFilterEvent[position], [`value`]: value };
                                   }
                                   setValues(newFilterEvent);
                                   setErrors({});
                              };

                              const handleDeleteFilter = (index) => {
                                   const newFilterEvent = [...values];
                                   newFilterEvent.splice(index, 1);
                                   setValues(newFilterEvent);
                                   setErrors({});
                              };

                              const handleChangeValueFilter = (e, index) => {
                                   const { name, value } = e.target;
                                   const newFilterEvent = [...values];
                                   newFilterEvent[index] = { ...newFilterEvent[index], [name]: value };
                                   setValues(newFilterEvent);
                              };

                              const handleClearAll = () => {
                                   if (!showData) return;

                                   if (isFilter.current) {
                                        setChangeData(true);
                                        setFilterEventReport(!filterEventReport);
                                   }

                                   if (!recordProfile) {
                                        setValues(defaultRow);
                                        setFilterEvent(defaultRow);
                                        handleFindView(REPORT_TAB_TYPES.FILTER, defaultRow);
                                   } else {
                                        setValues([filterEvent[0]]);
                                        setFilterEvent([filterEvent[0]]);
                                        handleFindView(REPORT_TAB_TYPES.FILTER, [filterEvent[0]]);
                                   }
                                   setFilterEventReport(!filterEventReport);
                                   isFilter.current = false;
                                   setErrors({});
                              };

                              const handleAddRow = () => {
                                   if (showData) {
                                        setValues([...values, ...defaultRow]);
                                   }
                              };

                              const handleChangeValueFilterDatePicker = (date, index) => {
                                   const newFilterEvent = [...values];
                                   newFilterEvent[index] = { ...newFilterEvent[index], [`value`]: date };
                                   setValues(newFilterEvent);
                              };

                              const handleSelectValue = (name, value) => {
                                   setFieldValue(name, value?.value)
                              }

                              const disableClearAll = values?.length === 1 && !values[0].value;
                              const disableApplyBtn = JSON.stringify(values) === JSON.stringify(localFilterEvent) && !rerunValueChange;

                              return (
                                   <CForm onSubmit={handleSubmit} noValidate>
                                        <div className="d-flex align-items-center justify-content-end">
                                             <ButtonClearAll
                                                  handleClearAll={handleClearAll}
                                                  triggerClear={triggerClear}
                                                  setTriggerClear={setTriggerClear}
                                                  disabled={disableClearAll}
                                             />
                                             <CButton onClick={handleSubmit} type="submit" className={`filter-button ${disableApplyBtn ? 'disabled' : ''}`}>
                                                  <CLabel>Apply</CLabel>
                                             </CButton>
                                        </div>
                                        {values.map((item, index) => {
                                             const typeValid = get(errors, `[${index}].type`);
                                             const valueValid = get(errors, `[${index}].value`);
                                             const booleanEmailSubFields = ['roleEmail', 'disposableEmail', 'catchAllEmail', 'primary', 'currentB2BRole'];
                                             const operatorArray = item?.type ? [...item.optionsOperator, ...handleChangeOperatorFilter({ index, value: item.type, newFilterEvent: [...values] })] : [];
                                             const optionsOperator = booleanEmailSubFields.includes(item?.operatorSubField)
                                                  ? cloneDeep(VARIABLE_OPERATORS_BOOLEAN_REPORT)
                                                  : removeDuplicateValueInArray(operatorArray);
                                             const operatorValue = optionsOperator?.find((option) => option.value === item.operator) || {
                                                  value: '',
                                                  label: 'Select...',
                                             };
                                             let operatorSubFieldOption = item?.optionSubFields;

                                             if (reportName === REPORT_NAMES.PERSON_DETAILS) {
                                                  if (!validateEmailStatus) {
                                                       if (item?.type === 'email') {
                                                            operatorSubFieldOption = [
                                                                 { value: 'email', label: 'Email' },
                                                                 { value: 'emailType', label: 'Email Type' },
                                                                 { value: 'isEmpty', label: 'Is Empty' },
                                                                 { value: 'isNotEmpty', label: 'Is Not Empty' }
                                                            ]
                                                       }

                                                       if (item?.type === 'emailList') {
                                                            operatorSubFieldOption = [
                                                                 { value: 'email', label: 'Email' },
                                                                 { value: 'emailType', label: 'Email Type' },
                                                                 { value: 'primary', label: 'Primary' },
                                                            ]
                                                       }
                                                  }
                                             }

                                             const operatorSubFieldValue = operatorSubFieldOption?.find((option) => option.value === item?.operatorSubField) || {
                                                  value: '',
                                                  label: 'Select Sub Field...',
                                             };
                                             const operatorArrayValue = item?.optionsArray?.find((option) => option.value === item.operatorArray) || {
                                                  value: '',
                                                  label: 'Select Array Operator...',
                                             };

                                             const customDate = customDimensionInfo.find((_property) => _property.dataSource === DATA_SOURCE_EXTERNAL_OBJECT && _property.properties === item.type && (formatFields.includes(_property.pathPropertyName) || _property.pathPropertyName.includes('date') || _property.pathPropertyName.includes('Date') || ['DATE', 'TIMESTAMP'].includes(_property.propertyType)) && ['FOL', 'LOL'].includes(_property.target));

                                             const customBoolean = customDimensionInfo.find((_property) => _property.dataSource === DATA_SOURCE_EXTERNAL_OBJECT && _property.properties === item.type && BOOLEAN_FIELD.includes(_property.pathPropertyName) && ['FOL', 'LOL'].includes(_property.target));
                                             const findFieldPropertyDynamic = propertyDynamic.find((el) => el.key === item.type);
                                             const conversionReport = reportType === REPORT_TYPE.SALES_CONVERSION;
                                             const isDateType = DATE_FILTER_TYPES.includes(item.type)
                                             const showDatePicker = (checkFieldDate(item.type) || checkFieldDate(item?.operatorSubField) || ((conversionReport || [REPORT_TYPE.SALES_CONVERSION].includes(reportType)) && checkFieldDate(item.type)) || formatFields.includes(item.type) || isDateType || customDate || (findFieldPropertyDynamic && ['DATE', 'TIMESTAMP'].includes(findFieldPropertyDynamic?.typeField))) && !['ct', 'nct'].includes(item.operator);
                                             const isBooleanField = BOOLEAN_FIELD.includes(item.type) || customBoolean || BOOLEAN_FIELD.includes(item?.operatorSubField) || booleanEmailSubFields.includes(item?.operatorSubField);
                                             const hiddenOperator = isBooleanField && ['currentRole'].includes(item?.operatorSubField)
                                             const isYesNoField = YES_NO_FIELD.includes(item.type) || YES_NO_FIELD.includes(item?.operatorSubField);
                                             let defaultValue = defaultValues ? (defaultValues.find((el) => el.key === item.type) || defaultValues.find((el) => el.key === item?.operatorSubField)) : null;
                                             const listChannel = CHECK_LIST_FIELD[CHECKLIST_TYPE.CHANNEL];
                                             const listUserSource = CHECK_LIST_FIELD[CHECKLIST_TYPE.USER_SOURCE];

                                             if (listChannel?.includes(item.type)) {
                                                  defaultValue = { optionsValue: checklistOptions?.channel };
                                             }
                                             if (listUserSource?.includes(item.type)) {
                                                  defaultValue = { optionsValue: checklistOptions?.userSource };
                                             }

                                             if (item.type && item?.operatorSubField && defaultValues) {
                                                  defaultValue = defaultValues.find((el) => el.key === `${item.type}-${item?.operatorSubField}`);
                                             }

                                             if (defaultValue?.key === 'conversionName') {
                                                  if (CHECKLIST_OPTION_ARRAY.some((el) => el.value === operatorValue.value)) {
                                                       defaultValue.optionsValue = conversionName.map((el) => ({ label: el.label.replace('Conv - ', ''), value: el.label.replace('Conv - ', '') }));
                                                  } else {
                                                       defaultValue.optionsValue = null;
                                                  }
                                             }

                                             const intentProperty = intentProperties.find((el) => [INTENT_PROPERTIES_STORE.MULTIPLE, INTENT_PROPERTIES_STORE.SINGLE].includes(el?.fieldType) && generateCustomDimensionName(`${el?.name}_intent`) === item.type);
                                             if (!!intentProperty) {
                                                  defaultValue = { key: item.type, options: optionsOperator, optionsValue: intentProperty?.classificationOptions?.map((el) => ({ label: el, value: el })) || [] };
                                             }
                                             return (
                                                  <Fragment key={index}>
                                                       <div
                                                            className={`d-flex align-items-top justify-content-end mt-2 position-relative ${recordProfile && index === 0 ? 'hide-delete-filter' : 0
                                                                 }`}
                                                       >
                                                            <div className={`select-filter ${typeValid ? 'is-invalid' : ''} `}>
                                                                 <SelectSearchField
                                                                      id="type"
                                                                      placeholder="Select..."
                                                                      options={typeOptions}
                                                                      value={
                                                                           filterOptions.find((option) => option.value === item.type) || {
                                                                                value: '',
                                                                                label: 'Select...',
                                                                           }
                                                                      }
                                                                      className={`select-react`}
                                                                      classNamePrefix="custom-select"
                                                                      isDisabled={recordProfile && index === 0}
                                                                      onChange={(e) =>
                                                                           handleChangeFilter({
                                                                                valueFilter: e,
                                                                                position: index,
                                                                                type: 'type',
                                                                           })
                                                                      }
                                                                 />
                                                                 {!!typeValid && <CInvalidFeedback className="d-block mb-0">{typeValid}</CInvalidFeedback>}
                                                            </div>
                                                            {item?.optionsArray?.length > 0 &&
                                                                 <div className="select-filter-operator">
                                                                      <Select
                                                                           classNamePrefix="react-select"
                                                                           name="value"
                                                                           options={item.optionsArray}
                                                                           value={operatorArrayValue}
                                                                           placeholder="Select..."
                                                                           onChange={(e) =>
                                                                                handleChangeFilter({
                                                                                     valueFilter: e,
                                                                                     position: index,
                                                                                     type: 'operatorArray',
                                                                                     field: item.type
                                                                                })
                                                                           }
                                                                           isDisabled={recordProfile && index === 0}
                                                                      />
                                                                 </div>
                                                            }
                                                            {operatorSubFieldOption?.length > 0 && !VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === item?.operatorArray) &&
                                                                 <div className="select-filter-operator">
                                                                      <Select
                                                                           classNamePrefix="react-select"
                                                                           name="value"
                                                                           options={operatorSubFieldOption}
                                                                           value={operatorSubFieldValue}
                                                                           placeholder="Select..."
                                                                           onChange={(e) =>
                                                                                handleChangeFilter({
                                                                                     valueFilter: e,
                                                                                     position: index,
                                                                                     type: 'operatorSubField',
                                                                                     field: item.type
                                                                                })
                                                                           }
                                                                           isDisabled={recordProfile && index === 0}
                                                                      />
                                                                 </div>
                                                            }
                                                            {(optionsOperator?.length > 1 || (optionsOperator?.length > 0 && !item.operator))
                                                                 && !VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === item?.operatorSubField)
                                                                 && !VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === item?.operatorArray) && !hiddenOperator ?
                                                                 <div className="select-filter-operator">
                                                                      <Select
                                                                           classNamePrefix="react-select"
                                                                           name="value"
                                                                           options={optionsOperator}
                                                                           value={operatorValue}
                                                                           placeholder="Select..."
                                                                           onChange={(e) =>
                                                                                handleChangeFilter({
                                                                                     valueFilter: e,
                                                                                     position: index,
                                                                                     type: 'operator',
                                                                                })
                                                                           }
                                                                           isDisabled={recordProfile && index === 0}
                                                                      />
                                                                 </div>
                                                                 : <></>
                                                            }

                                                            {
                                                                 !VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => el.value === item?.operatorSubField)
                                                                      && !VARIABLE_OPERATORS_EMPTY_REPORT.some((el) => [item?.operatorArray, item.operator].includes(el.value))
                                                                      && ![EXISTS_WITH_ANY_VALUE_OPERATOR_OPTION.value, DOES_NOT_EXIST_OPERATOR_OPTION.value].includes(item?.operator) ?
                                                                      <div className={`field-value-search `}>
                                                                           {item.operator !== 'dr' && item.operator !== 'ndr' && (
                                                                                <div className={`${valueValid ? 'is-invalid' : ''}`}>
                                                                                     {showDatePicker ? (
                                                                                          <CustomFilterDatePicker
                                                                                               onChange={(e) => handleChangeValueFilterDatePicker(e, index)}
                                                                                               value={item.value}
                                                                                               allowFutureDates={true}
                                                                                          />
                                                                                     ) : (operatorValue.value === CHECKLIST_OPTION.value || operatorValue.value === EXCLUDE_CHECK_LIST_OPERATOR_OPTION.value) ? (
                                                                                          <LazyLoadSelect
                                                                                               id={`${index}.value`}
                                                                                               name={`${index}.value`}
                                                                                               options={checklistOptions[item.type] || checklistOptions[item?.operatorSubField] || defaultValue?.optionsValue || []}
                                                                                               value={item.value}
                                                                                               isMulti={true}
                                                                                               onChange={setFieldValue}
                                                                                               touched={touched.checklist}
                                                                                               error={errors.checklist}
                                                                                               isClearable={true}
                                                                                               backspaceRemovesValue={true}
                                                                                               className={!!errors.checklist ? ' is-invalid' : ''}
                                                                                          />

                                                                                     ) : isBooleanField ? (
                                                                                          <SelectField
                                                                                               id={`${index}.value`}
                                                                                               name={`${index}.value`}
                                                                                               options={isYesNoField ? YES_NO_FIELD_OPTIONS: BOOLEAN_FIELD_OPTIONS}
                                                                                               value={item?.value ? { value: item?.value, label: item?.value } : { label: 'Select' }}
                                                                                               isMulti={false}
                                                                                               onChange={handleSelectValue}
                                                                                               onBlur={setFieldTouched}
                                                                                               isClearable={true}
                                                                                               backspaceRemovesValue={true}
                                                                                               setErrors={setErrors}
                                                                                          />
                                                                                     ) :

                                                                                          <CInput
                                                                                               value={typeof item.value === 'string' ? item.value : ''}
                                                                                               name="value"
                                                                                               onChange={(e) => handleChangeValueFilter(e, index)}
                                                                                               disabled={recordProfile && index === 0}
                                                                                          />
                                                                                     }
                                                                                </div>
                                                                           )}
                                                                           {!!valueValid && (
                                                                                <CInvalidFeedback className="d-block mb-0">{valueValid}</CInvalidFeedback>
                                                                           )}
                                                                      </div>
                                                                      :
                                                                      <></>
                                                            }

                                                            {((!recordProfile && values.length > 1) ||
                                                                 (recordProfile && index !== 0 && values.length > 1)) && (
                                                                      <CButton
                                                                           className="button-group field-parameter-button"
                                                                           onClick={() => handleDeleteFilter(index)}
                                                                      >
                                                                           <CIcon icon="iconDeleteField" className="icon-delete" />
                                                                      </CButton>
                                                                 )}
                                                       </div>
                                                  </Fragment>
                                             );
                                        })}
                                        <CFormGroup className=" d-flex align-items-center justify-content-end">
                                             <CButton className="btn-add-row" onClick={handleAddRow}>
                                                  <CIcon icon="iconAddField" className="icon-add" />
                                                  <CLabel className="add-row">ADD ROW</CLabel>
                                             </CButton>
                                        </CFormGroup>
                                   </CForm>
                              );
                         }}
                    </Formik>
               )}
               {rerunValueChange ? <div className="mt-2 text-end">Data has been updated. Please reapply filters to ensure the report shows the latest data.</div> : null}
          </div>
     );
};

ButtonClearAll.propTypes = {
     setTriggerClear: PropTypes.func,
     handleClearAll: PropTypes.func,
     triggerClear: PropTypes.any,
};

export default FilterReport;
